import React from 'react';
import { Eyebrow } from './Eyebrow';
import { NOW_LIST, AFTER_LIST } from '../data/landing';
export function ShiftSection() {
  return <section id="el-cambio" className="bg-cream-2 py-14 md:py-20" aria-labelledby="shift-title" data-id="element-177" data-mp="c5g2lfn3886x">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-178" data-mp="3ufrt1hdfibg8">
        <div className="mx-auto max-w-[620px] text-center" data-id="element-179" data-mp="2f3mbzmb316l">
          <Eyebrow data-id="element-180" data-mp="q3msa8hvv1vi">El cambio</Eyebrow>
          <h2 id="shift-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-181" data-mp="q4pj6gf7h4bf">
            De generar confianza a comunicar también intención y atracción
          </h2>
          <p className="mx-auto mt-4 max-w-[460px] text-[13px] font-medium leading-relaxed text-ink-muted md:text-[15px]" data-id="element-182" data-mp="h2oonrbcwwdg">
            A veces la conexión ya existe. Lo que falta es una dinámica que
            también permita expresar interés con claridad.
          </p>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-183" data-mp="36tv1ns35tqj1">
          <div className="flex flex-col rounded-[14px] border border-line bg-cream-soft p-5" data-id="element-184" data-mp="vfswsz0y2a3a">
            <div className="flex items-center gap-2" data-id="element-185" data-mp="qhhnqqih43m4">
              <h3 className="text-[13px] font-bold text-ink" data-id="element-186" data-mp="qj2ioh8p9oki">Ahora</h3>
              <span className="rounded-full bg-cream-2 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-ink-muted" data-id="element-187" data-mp="15fjqwzllen2u">
                Hoy
              </span>
            </div>
            <ul className="mt-3 divide-y divide-line/70" data-id="element-188" data-mp="1eeeyog4ac589">
              {NOW_LIST.map(item => <li key={item} className="flex gap-3 py-2.5 text-[12px] font-medium leading-relaxed text-ink-muted md:text-[13px]" data-id="element-189" data-mp="19gvihao11ido">
                  <span aria-hidden="true" className="text-ink-muted/70" data-id="element-190" data-mp="1j5djnt07xrhu">
                    —
                  </span>
                  <span data-id="element-191" data-mp="1x6pujq0iv2wv">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-[14px] border border-gold/40 bg-cream-soft p-5" data-id="element-192" data-mp="1t5e2zey387m1">
            <div className="flex items-center gap-2" data-id="element-193" data-mp="208m023tthxr0">
              <h3 className="text-[13px] font-bold text-ink" data-id="element-194" data-mp="256dup5lujxyw">
                Con Hombre Magnético
              </h3>
              <span className="rounded-full bg-gold/15 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-gold-muted" data-id="element-195" data-mp="2a4xilbk03jtw">
                Desde hoy
              </span>
            </div>
            <ul className="mt-3 divide-y divide-line/70" data-id="element-196" data-mp="2iyahqv8nrhof">
              {AFTER_LIST.map(item => <li key={item} className="flex gap-3 py-2.5 text-[12px] font-medium leading-relaxed text-ink md:text-[13px]" data-id="element-197" data-mp="2nw2k6j6xim6v">
                  <span aria-hidden="true" className="text-gold" data-id="element-198" data-mp="2xurrxj542q9e">
                    ✦
                  </span>
                  <span data-id="element-199" data-mp="yigv6fwgcok0">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-200" data-mp="13i1uwsjg50xs">
          Seguridad · Conversación · Intención · Atracción
        </p>
      </div>
    </section>;
}